import * as React from 'react';
import LocaleFormating from 'src/translation/localeFormating';

import { IInvoiceEcheck } from '../../ECheckForm';

import './ECheckInvoiceTable.scss';

interface IECheckInvoiceTableProps {
  invoice: IInvoiceEcheck;
  userAccount: string;
}

class ECheckInvoiceTable extends React.Component<
  IECheckInvoiceTableProps,
  any
> {
  public render() {
    return (
      <div className="rp-echeck-invoice-table-row row">
        <div className="col-2 rp-echeck-invoice-table-col d-flex justify-content-start">
          {this.props.invoice.invoiceNumber}
        </div>
        <div className="col-2 rp-echeck-invoice-table-col d-flex justify-content-start">
          {this.props.invoice.invoiceDate}
        </div>
        <div className="col-2 rp-echeck-invoice-table-col d-flex justify-content-start">
          {this.props.userAccount}
        </div>
        <div className="col-2 rp-echeck-invoice-table-col d-flex justify-content-start">
          <span>
            {LocaleFormating.formatCurrency(this.props.invoice.total)}
          </span>
        </div>
        <div className="col-2 rp-echeck-invoice-table-col d-flex justify-content-start">
          <span>
            {LocaleFormating.formatCurrency(this.props.invoice.payment)}
          </span>
        </div>
        <div className="col-2 rp-echeck-invoice-table-col d-flex justify-content-start">
          {this.props.invoice.notes}
        </div>
      </div>
    );
  }
}

export default ECheckInvoiceTable;
